import React, { useEffect } from "react";
import "firebase/auth";
import Auth from "../../api/auth";
import { IonContent, IonPage, IonLoading } from "@ionic/react";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";

const LogOut = () => {
  const history = useHistory();
  const intl = useIntl();

  useEffect(() => {
    async function signOut() {
      await Auth.signOut();
      history.replace("/login");
    }
    signOut();
  }, []);

  return (
    <IonPage>
      <IonContent>
        <IonLoading
          isOpen={true}
          message={intl.formatMessage({
            id: "app.mobile.signing_out",
          })}
          duration={5000}
        />
      </IonContent>
    </IonPage>
  );
};

export default LogOut;
